var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardLayout',[_c('div',{staticClass:"card-default"},[_c('div',{staticClass:"card-default__key"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-default__val"},[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }